import {useContext} from 'react'
import {RouterContext} from 'providers/context'

function useRouter () {
  return useContext(RouterContext)
}

export default useRouter
